import { render, staticRenderFns } from "./SysDialogConfimacao.vue?vue&type=template&id=5575adb7&scoped=true"
import script from "./SysDialogConfimacao.vue?vue&type=script&setup=true&lang=js"
export * from "./SysDialogConfimacao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5575adb7",
  null
  
)

export default component.exports